module.exports = __webpack_public_path__ + "static/media/ser-6.98265e5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ser-6.png
// module id = 207
// module chunks = 0